<div class="data-sources-controls-wrapper">
  <button
    *ngFor="let button of dataSourcesService.dataSourcesText"
    class="data-sources-control"
    (click)="dataSourcesService.updateActiveButton(button[0])"
    [ngClass]="{'active': dataSourcesService.activeButtons.includes(button[0])}"
  ><span>{{button[0]}}</span></button>
</div>
